/** Immutable View: a structure the caller can filter the costs by. */
class AiCostOrganizationOptionView {
	readonly id: number;
	readonly label: string;

	constructor(payload: { readonly id: number; readonly label: string }) {
		this.id = payload.id;
		this.label = payload.label;

		Object.freeze(this);
	}
}

export default AiCostOrganizationOptionView;
